// Auto-generated version file - DO NOT EDIT MANUALLY
// Generated on: 2026-11-05T15:32:47.883Z
// Build environment: production

export interface AppVersion {
  version: string;           // Full semantic version (e.g., "1.2.345")
  fullVersion: string;       // Full version with metadata (e.g., "1.2.345-staging+20251114052718")
  shortVersion: string;      // Version with environment (e.g., "1.2.345-staging")
  environment: string;       // Build environment (e.g., "staging" or "production")
  buildTimestamp: string;    // Build timestamp (e.g., "20251114052718")
  buildDate: string;         // Human readable build date (e.g., "2025-11-14 05:27:18 UTC")
  gitCommit: string;         // Git commit hash (e.g., "a1b2c3d")
}

export const APP_VERSION: AppVersion = {
  version: '1.0.247',
  fullVersion: '1.0.247-production+261105153247',
  shortVersion: '1.0.247-production',
  environment: 'production',
  buildTimestamp: '261105153247',
  buildDate: '2026-11-05 15:32:47 UTC',
  gitCommit: 'bafc9a5',
};
